import React, { useEffect } from "react";
import api from "../common/lib/api";

import DynamicTable from "../common/components/DynamicTable";
import DateCellRenderer from "../common/components/DynamicTable/DateCellRenderer";
import LinkCellRenderer from "../common/components/DynamicTable/LinkCellRenderer";
import DefaultRowRenderer from "../common/components/DynamicTable/DefaultRowRenderer";
import { Link } from "react-router-dom";
import { accessor } from "../common/components/DynamicTable/DefaultCellRenderer";
import DefaultToolbar from "../common/components/DynamicTable/DefaultToolbar";
import { useManaged } from "../common/components/Managed";

function RowRenderer(props) {
  const extra = {};
  if (!props.row.dispatchedAt) {
    extra.style = {
      backgroundColor: "rgba(200,100,0, 0.3)",
    };
  }
  return <DefaultRowRenderer {...props} {...extra} />;
}

export function TrackingDetails({ value }) {
  if (!value) {
    return "";
  }
  return (
    <>
      {value.map((item) => {
        let link = item.freightTrackingWebsite;
        let text = `${item.freightShippingMethod}`;
        let suffix = `: ${item.deliveryTrackingCode}`;
        let button = null;

        switch (item.freightShippingMethod) {
          case "Couriers Please":
            link =
                "https://www.couriersplease.com.au/tools-track?no=" +
                item.deliveryTrackingCode;
            break;

          case "Express Post":
            link =
              "https://auspost.com.au/mypost/track/#/details/" +
              item.deliveryTrackingCode;
            break;

          case "In Express":
            if (item.deliveryTrackingCode.indexOf("IXX") === 0) {
              link = "http://tntexpress.com.au/interaction/trackntrace.aspx";
            } else if (item.deliveryTrackingCode.indexOf("27KZ") === 0) {
              link = "https://startrack.com.au/";
            } else if (item.deliveryTrackingCode.indexOf("AQRD") === 0) {
              link = "http://www.tollgroup.com/all-tools";
            } else {
              link = `https://www.dhl.com/au-en/home/tracking.html?tracking-id=${item.deliveryTrackingCode}&submit=1`;
            }
            break;

          default:
        }

        return (
          <li>
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {text}
            </a>
            {suffix} {button}
          </li>
        );
      })}
    </>
  );
}

const fields = {
  saleDate: {
    cellRenderer: DateCellRenderer.make("YYYY-MM-DD"),
  },
  dispatchedAt: {
    cellRenderer: DateCellRenderer.make("YYYY-MM-DD"),
  },
  saleOrderDisplayId: {
    cellRenderer: LinkCellRenderer.make((v, f, row) => {
      return `/sale-order/${row.saleOrderId}`;
    }),
  },
  deliveryTrackingCode: {
    cellRenderer: function LinkCellRenderer({ row, head }) {
      const { label } = head;
      const value = accessor(row, head.field);

      return (
        <td
          className={`DynamicTableData__Cell__${(label || "").replace(
            " ",
            "_"
          )}`}
        >
          <TrackingDetails value={value} />
        </td>
      );
    },
  },
  companyName: {
    cellRenderer: function LinkCellRenderer({ row, head }) {
      const { label } = head;
      const value = accessor(row, head.field);
      const shipToAddress = accessor(row, "shipToAddress");
      const companyId = accessor(row, "companyId");

      return (
        <td
          className={`DynamicTableData__Cell__${(label || "").replace(
            " ",
            "_"
          )}`}
          title={shipToAddress}
        >
          <Link to={`/companies/${companyId}`}>{value}</Link>
        </td>
      );
    },
  },
  orderSize: {
    cellRenderer: function LinkCellRenderer({ row, head }) {
      const { label } = head;
      const value = accessor(row, head.field);
      let lines = accessor(row, "lines");

      if (typeof lines === "string") {
        lines = JSON.parse(lines);
      }

      if (Array.isArray(lines)) {
        lines = lines
          .filter((line) => line.itemId !== "Freight")
          .map((line) => {
            return `${line.itemId} x ${line.quantity}`;
          })
          .join("\n");
      }

      return (
        <td
          className={`DynamicTableData__Cell__${(label || "").replace(
            " ",
            "_"
          )}`}
          title={lines}
        >
          {value}
        </td>
      );
    },
  },
};

const DEFAULT_NEW_ORDER_OPTIONS = [];

export default function Page() {
  const [state, setData, setError] = useManaged(DEFAULT_NEW_ORDER_OPTIONS);

  useEffect(() => {
    api
      .get("/sale-orders/new/systems")
      .then((x) => setData(x.data.data), setError);
  }, [setData, setError]);

  const { data } = state;

  return (
    <>
      <h1>Sale Orders</h1>
      <p>
        {data.map((system) => (
          <Link
            to={`/sale-order-new/${system}`}
            className="bp3-button bp3-intent-primary"
          >
            New {system.substring(0, 1).toUpperCase()}{system.substring(1)} Order
          </Link>
        ))}
      </p>
      <DynamicTable
        endpoint={"/sale-orders/table"}
        fields={fields}
        rowRenderer={RowRenderer}
        toolbarRenderer={DefaultToolbar}
      />
    </>
  );
}
